<template>
  <div
    v-if="dialog.open"
    class="mlui-core-dialog">
    <div class="mlui-core-dialog-overlay" />
    <div
      class="mlui-core-dialog-pop-up tw-p-3 tw-flex tw-flex-col tw-gap-4 tw-bg-core-neutral-cold-100 tw-justify-between tw-rounded-md"
      :class="dialog.dialogClass"
      :data-test="dialog.dataTest">
      <div class="mlui-core-dialog-pop-up-header tw-p-3 tw-flex tw-items-center tw-gap-4">
        <SVGIcon
          v-if="iconName !== ''"
          :colorClass="iconColorClass"
          :iconName="iconName" />
        <div class="headlines--headline-05 tw-text-core-neutral-cold-30">
          {{ data.title }}
        </div>
      </div>
      <div
        v-if="dialog.body"
        class="mlui-core-dialog-pop-up-body tw-px-3 body--body-01 tw-text-core-neutral-cold-30"
        v-html="dialog.body" />
      <div 
        class="tw-flex tw-flex-row-reverse tw-gap-4 tw-p-3"
        :class="data.footerClass">
        <CoreButton
          v-if="dialog.firstButton"
          :buttonType="buttonTypeConfirmation"
          :label="dialog.firstButton.text"
          :data-test="dataTestConfirmationButton"
          @click="onConfirm" />
        <CoreButton
          v-if="dialog.secondButton"
          :buttonType="buttonTypeReject"
          :label="dialog.secondButton.text"
          :data-test="dataTestRejectButton"
          @click="onReject" />
      </div>
    </div>
  </div>
</template>

<script>
import CoreButton from 'frontcore/components/CoreButton.vue'
import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'

export default {
  name: 'CoreDialog',
  components: {
    SVGIcon,
    CoreButton,
  },
  props: {
    data: {
      type: Object,
    },
  },
  data () {
    return {
      dialog: this.data,
    }
  },
  computed: {
    dataTestConfirmationButton () {
      return this.dialog.dataTestFirstButton ?? 'confirm-button'
    },
    dataTestRejectButton () {
      return this.dialog.dataTestSecondButton ?? 'reject-button'
    },
    buttonTypeConfirmation () {
      return this.dialog.firstButton.template === 'danger' ? 'destructive-primary' : 'primary'
    },
    buttonTypeReject () {
      if (this.dialog.secondButton.template === 'danger') {
        return 'destructive-primary'
      }
      return this.dialog.secondButton.template === 'default' ? 'secondary' : 'ghost'
    },
    iconColorClass () {
      return this.dialog.template === 'delete' ? 'fill-auxiliary-error-50' : 'fill-auxiliary-info-50'
    },
    iconName () {
      switch (this.dialog.template) {
      case 'delete':
        return 'Trash'
      case 'info':
        return 'Info'
      case 'close':
        return 'CheckFill'
      default:
        return ''
      }
    },
  },
  watch: {
    data (newValue) {
      this.dialog = newValue
    },
  },
  methods: {
    onConfirm () {
      this.dialog.open = false
      if (this.dialog.onConfirmCallback) this.dialog.onConfirmCallback(this.dialog.payload)
    },
    onReject () {
      this.dialog.open = false
      if (this.dialog.onRejectCallback) this.dialog.onRejectCallback(this.dialog.payload)
    },
  },
}
</script>

<style lang="css" scoped>
@media only screen and (max-device-width: 768px) {
  .mlui-core-dialog .mlui-core-dialog-pop-up {
    width: 80% !important;
    min-height: 200px;
  }
}

.mlui-core-dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1041;
  display: flex;
  align-items: center;
  justify-content: center;

  .mlui-core-dialog-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.5;
    background-color: #29343a;
  }

  .mlui-core-dialog-pop-up {
    z-index: 1;
  }
}
</style>
